import React from "react";
import { useSearchParams } from "react-router";

import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Stack from "@mui/material/Stack";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

export enum DetailsTabId {
  Details = "details",
  Payments = "payments",
}

export const detailsTabs = [
  {
    id: DetailsTabId.Details,
    label: "Деталі",
  },
  {
    id: DetailsTabId.Payments,
    label: "Платежі",
  },
];

interface InvoiceDetailsTabsProps {
  visibleTab: DetailsTabId;
  setVisibleTab: (tabId: DetailsTabId) => void;
}

export const InvoiceDetailsTabs: React.FC<InvoiceDetailsTabsProps> = (
  props,
) => {
  const { visibleTab, setVisibleTab } = props;
  const [searchParams, setSearchParams] = useSearchParams();

  const handleTabChange = (_: React.SyntheticEvent, newValue: DetailsTabId) => {
    const nextSearchParams = new URLSearchParams(searchParams);

    analytics().sendConversionEvent(
      AnalyticsEvents.invoice_details_tab_click,
      { tab: newValue },
      true,
    );

    if (newValue === DetailsTabId.Details) {
      nextSearchParams.delete("tab");
    } else {
      nextSearchParams.set("tab", newValue);
    }

    setSearchParams(nextSearchParams, { replace: true });
    setVisibleTab(newValue);
  };

  return (
    <Stack spacing={2} alignItems="flex-start" sx={{ mb: 3 }}>
      <Tabs value={visibleTab} onChange={handleTabChange}>
        {detailsTabs.map((tab) => (
          <Tab
            sx={{ p: "4px 16px", "&.Mui-selected": { color: "grey900" } }}
            key={tab.id}
            value={tab.id}
            label={tab.label}
            data-testid={`invoice-details-tab-${tab.id}`}
          />
        ))}
      </Tabs>
    </Stack>
  );
};

export default InvoiceDetailsTabs;
